import { EMPLOYEE_USER_BENEFITS_RESET } from './reset-user-benefits.action-types';

export const resetEmployeeUserBenefits = payload => ({
  type: EMPLOYEE_USER_BENEFITS_RESET,
  payload,
});
